// extracted by mini-css-extract-plugin
export default {"path-wrapper":"TopicPath_path-wrapper__+F+h7","path-item":"TopicPath_path-item__MPExU"};